import { Navigate } from 'react-router-dom';
import { Route, Routes, BrowserRouter as Router, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { PATHS, privatRoutes, publicRoutes } from '../../router/routes.js';
import ProtectedRoute from './ProtectedRoute.jsx';
import AgentConfiguration from 'pages/agent-configuration';
import FullAgentConfiguration from 'pages/agent-configuration/FullAgentConfiguration';
import AgentConfigurationKnowledgeBase from 'pages/agent-configuration/KnowledgeBase';
import AgentConfigurationGreeting from 'pages/agent-configuration/AgentGreeting';
import AgentConfigurationCallTransfers from 'pages/agent-configuration/CallTransfers';
import AgentConfigurationChatSimulation from 'pages/agent-configuration/ChatSimulation';
import AgentConfigurationMoreSettings from 'pages/agent-configuration/MoreSettings';
import AgentConfigurationTrainingGuide from 'pages/agent-configuration/TrainingGuide';

const RouteTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Skip tracking for Django-served paths
        if (location.pathname.startsWith('/django')) {
            return;
        }

        // Track Facebook PageView
        if (window.fbq) {
            window.fbq('track', 'PageView');
        }

        // Initialize dataLayer if not exists (idempotent)
        window.dataLayer = window.dataLayer || [];
        
        // Push pageview event to GTM dataLayer
        window.dataLayer.push({
            event: 'pageview',
            page_path: location.pathname + location.search + location.hash,
        });
    }, [location]);

    return null;
};

const Navigation = ({ isAuth }) => {
    return (
        <Router>
            <RouteTracker />
            <Routes>
                {publicRoutes.map((route) => {
                    return <Route key={route.path} element={<route.component />} path={route.path} />;
                })}
                <Route element={<ProtectedRoute isAuth={isAuth} />}>
                    {privatRoutes.map((route) => {
                        return <Route key={route.path} element={<route.component />} path={route.path} />;
                    })}
                    <Route path='agent-configuration/:id' element={<AgentConfiguration />}>
                        <Route path='training/*' element={<FullAgentConfiguration />} />
                        <Route path='transfers/*' element={<AgentConfigurationCallTransfers />} />
                        <Route path='chat/*' element={<AgentConfigurationChatSimulation />} />
                        <Route path='more-settings/*' element={<AgentConfigurationMoreSettings />} />
                        <Route path='' element={<AgentConfigurationTrainingGuide />} />
                    </Route>
                </Route>
                <Route path='/' element={<Navigate to={isAuth === false ? PATHS.SIGN_IN : PATHS.MY_AGENT} replace />} />
                <Route path='/*' element={<Navigate to={PATHS.PAGE_NOT_FOUND} replace />} />
            </Routes>
        </Router>
    );
};

export default Navigation;
